import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';
import styles from './styles.module.css';
import renderListOfActivitiesTypes from '../utils/renderListOfActivitiesTypes';

export default function ExtracurricularActivities({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [useAllactivities, setUseAllActivities] = useState([]);
  const [extracurricularActivities, setExtracurricularActivities] = useState({});
  const [count, setCount] = useState(0);

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;

      const artisticActivities = {
        properties: await assignValueById(activities, 3),
        title: 'Actividades Artísticas',
      };
      const culturalActivities = {
        properties: await assignValueById(activities, 4),
        title: 'Actividades Culturales',
      };
      const sportActivities = {
        properties: await assignValueById(activities, 5),
        title: 'Actividades Deportivas',
      };

      const extracurricular = await assignValueById(activities, 2);
      setExtracurricularActivities(extracurricular);

      if (culturalActivities.length === 0
        && artisticActivities.length === 0
        && sportActivities.length === 0
      ) {
        setUseAllActivities(null);
      } else {
        setUseAllActivities([
          artisticActivities,
          culturalActivities,
          sportActivities,
        ]);
      }
    };

    loadActivities();
  }, [activities]);

  useEffect(() => {
    if (!useAllactivities) return;
    setCount(0); // Reset count before recounting
    useAllactivities.forEach((activity) => {
      if (activity.properties.length > 0) {
        setCount((prevCount) => prevCount + 1);
      }
    });
  }, [useAllactivities]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!count) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection
      title="Actividades Extracurriculares"
      subtitleLyrics={{
        subtitle: 'Información sobre las actividades extracurriculares de la Institución',
        lyrics: extracurricularActivities[0]?.description,
      }}
    >
      <div className={styles.sectionsContainer}>
        {renderListOfActivitiesTypes(useAllactivities)}
      </div>
    </ProfileSection>
  );
}

ExtracurricularActivities.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
